import { Component, OnInit, ViewChild, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { AccountService } from '../_services/account.service';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { Router, ActivatedRoute } from '@angular/router';
import { PRODUCT_CONFIG } from '../../_common/product-config';
import { SortEvent, SortableDirective } from 'src/app/_directives/sortable.directive';
import { PageCriteria } from 'src/app/_models/page-criteria';
import { StatusCode, ReportingPeriodDescription, BillingType, ReportDetailType, Modules } from 'src/app/_common/_enum/module.enum';
import { MrReportingDetailsComponent } from '../mr-reporting-details/mr-reporting-details.component';

export enum BillingView {
  BillingOverview = "Billing Overview",
  InstallmentSchedule = "Installment Plan",
  MonthlyReporter = "Monthly Reporter",
  Payments = "Payments"
}

export enum BillingViewHeader {
  BillingOverview = "Billing Overview",
  InstallmentSchedule = "Installment Schedule",
  MonthlyReporter = "Reporting History",
  Payments = "Payment History"
}

@Component({
  selector: 'app-direct-bill-by-account',
  templateUrl: './direct-bill-by-account.component.html',
  styleUrls: ['./direct-bill-by-account.component.scss']
})
export class DirectBillByAccountComponent implements OnInit, OnDestroy  {
  resultsNotFound = RESULTS_NOT_FOUND;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private selectedView: string = BillingView.BillingOverview;
  private selectedAccount;
  private accountNumber;
  private selectedBillingAccountBalance;
  private hasPolicies: boolean = false;
  private selectedBillingAccountData;

  private installmentSchedules = [];
  private accountPayments = [];
  private mrPoliciesHistory = [];
  private headerLoading: boolean = false;
  private loading: boolean = false;
  private installmentScheduleLoading: boolean = false;
  private paymentsLoading: boolean = false;
  private mrLoading: boolean = false;
  private downloadingInvoiceNumber = []; // We are getting null from DB so not putting default value null.
  private modalDataLoading: boolean = false;
  private reportLoading: boolean = false;
  private documentLoading: any = [];

  private expandInvoice:boolean[];
  private expandPayment:boolean[];
  private productConfig = PRODUCT_CONFIG;

  private noticesList: any;

  private criteria: PageCriteria;

  private rpDescEnum = ReportingPeriodDescription;
  private billingTypeEnum = BillingType;
  private accHasInstallmentPlan: boolean = false;
  private accHasMonthlyReporter: boolean = false;

  private isReportingPeriodOpen: boolean = false;
  private isFinalAudit: boolean = false;
  private reportingStartDate: any;
  private reportingEndDate: any;
  private viewExposure: boolean = false;
  private reportDetailTypeEnum = ReportDetailType;
  private detailType: any;
  private reportingLob: any;
  private policyNumber: any;
  private noticePolicyNumber: string = "";
  private policyReportingDetails: any;
  private hasAccess:boolean = false;


  @ViewChild("viewNotices", {static: false}) viewNotices;
  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;
  @ViewChild(MrReportingDetailsComponent, {static: false}) mrReportingDetails:MrReportingDetailsComponent;

  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;

  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService) { }

  ngOnInit() {
    this.selectedAccount = this.accountService.getAccountData();
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {
      this.accountNumber = params.get("id").toString();
    });
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    
    this.fetchBillingAccountHeader();
    this.fetchBillingAccountData();
  }

  setHeaderData(){
    this.headerData.pageTitle = this.selectedAccount.accountName;
    this.headerData.breadcrumb = [{itemName: "Account Overview", itemLink: ""}];
    this.headerData.subTitle = "Account #: " + this.selectedAccount.accountNumber;
    this.accountService.header = this.headerData;
  }

  showEndorsementsTab(){    
    let getEndtFlag = this.accountService.endtTabFlag(this.selectedAccount).subscribe( (result: boolean) => { this.selectedAccount.accountEndorsementsTab = result });
    this.accountService.runningServices.push(getEndtFlag);
  }

  fetchBillingAccountHeader(){
    this.headerLoading = true;
    if(this.selectedAccount && this.selectedAccount.accountNumber == this.accountNumber){
      this.accountNumber = this.selectedAccount.accountNumber;
    }
    let headerSubscription = this.accountService.fetchBillingAccountHeader(this.accountNumber).subscribe((data:any)=>{
      this.headerLoading = false;
      this.hasAccess = true;
      if(data){
        this.selectedAccount = {"accountName": data.accountName, "accountNumber": data.accountNumber, "accountEndorsementsTab": ((this.selectedAccount && this.selectedAccount.accountEndorsementsTab != null)?this.selectedAccount.accountEndorsementsTab: null)};
        this.accountService.storeAccountData(this.selectedAccount);
        this.selectedBillingAccountBalance = data.balance;
        data.billType.forEach(type => {
          if (type === this.billingTypeEnum.Direct) this.accHasInstallmentPlan = true;
          if (type === this.billingTypeEnum.MonthlyReporter) this.accHasMonthlyReporter = true;          
        });

        this.selectedAccount.billType = data.billType;
        
      } else{
        this.selectedBillingAccountBalance = null;
      }
      this.showEndorsementsTab();
    },
    error=>{
      this.headerLoading = false;
      this.selectedBillingAccountBalance = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(headerSubscription);
  }

  fetchBillingAccountData(){
    this.loading = true;
    this.hasPolicies = false;
    let overviewSubscription = this.accountService.fetchBillingAccountData(this.accountNumber).subscribe((data:any)=>{
      this.loading = false;
      this.hasAccess = true;
      this.selectedBillingAccountData = data;
      this.hasPolicies = this.selectedBillingAccountData && this.selectedBillingAccountData.length > 0;
    },
    error=>{
      this.loading = false;
      this.hasPolicies = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.accountService.runningServices.push(overviewSubscription);
  }

  showDirectBillPolicies(){
    this.selectedView = this.BillingViewEnum.BillingOverview;
  }

  showInstallmentSchedules(){
    if(this.selectedView !== this.BillingViewEnum.InstallmentSchedule){
      this.selectedView = this.BillingViewEnum.InstallmentSchedule;
      if(this.installmentSchedules.length === 0){
        this.fetchInstallmentSchedulesByAccount();
      }
    }
  }

  showMonthlyReporter(){
    console.log('this.selectedView :: ', this.selectedView);
    if(this.selectedView !== this.BillingViewEnum.MonthlyReporter){
      this.selectedView = this.BillingViewEnum.MonthlyReporter;
      if(this.mrPoliciesHistory.length === 0){
        this.fetchMonthlyReporterAccount();
      }
    }
  }

  showPayments(){
    if(this.selectedView !== this.BillingViewEnum.Payments){
      this.selectedView = this.BillingViewEnum.Payments;
      if(this.accountPayments.length === 0){
        this.fetchPaymentsByAccount();
      }
    }
  }

  fetchInstallmentSchedulesByAccount(){
    this.installmentScheduleLoading = true;
    let installmentScheduleSubscription = this.accountService.fetchInstallmentSchedulesByAccount(this.accountNumber).subscribe((policies:any) => {
      this.installmentSchedules = policies;
      this.expandInvoice = this.installmentSchedules.map(()=>true);
      console.log(this.installmentSchedules);
      this.installmentScheduleLoading = false;
    },error=>{
      this.installmentScheduleLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(installmentScheduleSubscription);
  }

  fetchPaymentsByAccount(){
    this.paymentsLoading = true;
    let paymentsSubscription = this.accountService.fetchPaymentsByAccount(this.accountNumber).subscribe((policies:any) => {
      this.accountPayments = policies.accountPayments;
      this.expandPayment = this.accountPayments.map(()=>true);
      console.log(this.accountPayments);
      this.paymentsLoading = false;
    },error=>{
      this.paymentsLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(paymentsSubscription);
  }

  fetchMonthlyReporterAccount() {
    this.mrLoading = true;
    let monthlyReporterSubscription = this.accountService.fetchMonthlyReporterByAccount(this.accountNumber).subscribe((result:any) => {
      console.log('result ::', result);
      this.mrPoliciesHistory = result;
      this.checkIfOpenReportingMonth();
      this.mrLoading = false;
    },error=>{
      this.mrLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(monthlyReporterSubscription);
  }

  checkIfOpenReportingMonth() {
    this.isReportingPeriodOpen = false;
    this.isFinalAudit = false;

    this.mrPoliciesHistory.forEach(_policy => {
      let reportingPeriodsInfo = _policy.reportingPeriodsInfo;

      _policy.reportingPeriods.forEach(_period => {
        _period.isReportingPeriodOpen = false;
      });

      if(reportingPeriodsInfo && (reportingPeriodsInfo.openReportingPeriod || reportingPeriodsInfo.missedReportingPeriod)) {
        let _reportingPeriod = reportingPeriodsInfo.reportingPeriod;

        for(let i = 0; i < _policy.reportingPeriods.length; i++) {
          if (_policy.reportingPeriods[i].description === _reportingPeriod.description) {
            _policy.reportingPeriods[i].isReportingPeriodOpen = true;
          }
          //For Final Audit flag
          else if(_policy.reportingPeriods[i].description === ReportingPeriodDescription.Audit) {
            _policy.isFinalAudit = true;
          }
        }
      }
    });
  }

  get BillingViewEnum(){
    return BillingView;
  }

  get BillingViewHeaderEnum(){
    return BillingViewHeader;
  }

  get ModuleEnum(){ return Modules; }

  viewAccountActivity(){
    this.router.navigateByUrl("accounts/"+this.accountNumber+"/activity");
  }

  getBillingStatus(status){
    let cls = status.toLowerCase();
    if(status.toLowerCase().includes("cancelled"))
      cls = "cancelled";
    else if(status.toLowerCase().includes("pending") && status.toLowerCase().includes("cancellation"))
      cls = "pending-cancellation";
      
    return cls;
  }  

  fetchNoticeList(_accountNumber: string, _policyNumber: string) {
    this.modalDataLoading = true;
    this.noticePolicyNumber = _policyNumber;
    let noticeListSubscription = this.accountService.fetchNoticeList(_accountNumber, _policyNumber).subscribe((data:any)=>{
      this.noticesList = data;
      this.noticesList.forEach(notice => {
        notice.isDownloading = false;
      });
      this.accountService.openModal('none', this.viewNotices);    // View Notices Modal
      this.modalDataLoading = false;
    },error=>{
      this.modalDataLoading = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.accountService.runningServices.push(noticeListSubscription);
  }

  downloadInvoice(_accountNumber: string, _invoiceNumber: string){
    if(_invoiceNumber){
      this.downloadingInvoiceNumber.push(_invoiceNumber);
      this.accountService.downloadInvoice(_accountNumber, _invoiceNumber).subscribe(data=>{
        this.downloadingInvoiceNumber.splice(this.downloadingInvoiceNumber.indexOf(_invoiceNumber),1);
      },
      error => {
        this.downloadingInvoiceNumber.splice(this.downloadingInvoiceNumber.indexOf(_invoiceNumber),1);
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });
    }
  }

  openViewNoticesModal(_policyNumber: string, _idx) {
    this.fetchNoticeList(this.accountNumber, _policyNumber);    
  }

  downloadMRDcouments(_accountNumber: string, _documentid: string, _index) {/* '10091809', '0000004388' */
    this.documentLoading[_index] = true;
    let downloadMRDocumentsSubscription = this.accountService.downloadMRDcouments(_accountNumber, _documentid).subscribe(data => {
      if(!data) {
        setTimeout(() => {
          this.accountService.openModal('error', 'none');
        }, 50);
      }
      this.documentLoading[_index] = false;
    },
    error => {
      this.hasAccess = !(error.status == StatusCode.NoAccess);
      let hasOpenModals = this.accountService.hasOpenModals();
      if (hasOpenModals) {
        this.accountService.closeModal();
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.accountService.openModal('error', 'none');
        }, 50);
      }

      this.documentLoading[_index] = false;
    });

    this.accountService.runningServices.push(downloadMRDocumentsSubscription);

  }

  downloadNotice(notice){
    notice.isDownloading = true;
    this.accountService.downloadNotice(notice, this.accountNumber).subscribe(data=>{
      notice.isDownloading = false;
    },
    error => {
        notice.isDownloading = false;
        let hasOpenModals = this.accountService.hasOpenModals();
        if (hasOpenModals) {
          this.accountService.closeModal();
        }
        if(error.status == StatusCode.NoAccess) {        
          setTimeout(() => {
            this.accountService.openModal('none', this.lossRunErrorModal);
          }, 50);
        } 
        
        if(error.status == StatusCode.InternalServer) {
          setTimeout(() => {
            this.accountService.openModal('error', 'none');
          }, 50);
        }
    });
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    this.accountService.openModal('none', this.lossRunMessageModal);
    this.accountService.downloadLossRunReport(this.selectedAccount.accountNumber, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.accountService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.accountService.hasOpenModals();
      if (hasOpenModals) {
        this.accountService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.accountService.openModal('none', this.lossRunErrorModal);
        }, 50);
      } 
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.accountService.openModal('error', 'none');
        }, 50);
      }
    });
  }

  getMonthlyExposure(_reportingPeriod, _detailType, _policyDetails, _viewExposure) {
    this.viewExposure = _viewExposure;

    this.policyReportingDetails = {
      accountNumber: this.accountNumber,
      reportingPeriod: _reportingPeriod,
      detailType: _detailType,
      policyNumber: _policyDetails.policyNumber,
      lobShortName: _policyDetails.lobShortName,
      lobName: _policyDetails.lobName,
      policyEffectiveDate: _policyDetails.policyEffectiveDate,
      policyExpirationDate: _policyDetails.policyExpirationDate
    }    
  }

  returnToReportingSchedule ($event) {
    this.viewExposure = $event;
  }
  
  ngOnDestroy() {
    this.accountService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
